'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reduxForm = require('redux-form');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _RealtorField = require('../Realtor/RealtorContactUs/RealtorField/RealtorField');var _RealtorField2 = _interopRequireDefault(_RealtorField);
var _components = require('../../components');

var _reduxFormValidators = require('../../helpers/reduxFormValidators');
var _validate = require('../../utils/validate');



var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);


var _PublishAuthentication = require('./PublishAuthentication.scss');var styles = _interopRequireWildcard(_PublishAuthentication);
var _SocialNetworkAuthentication = require('../UserAuthentication/SocialNetworkAuthentication/SocialNetworkAuthentication');var _SocialNetworkAuthentication2 = _interopRequireDefault(_SocialNetworkAuthentication);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} // styles


var idPrefix = 'publish-authentication-form';

var PublishAuthentication = function PublishAuthentication(props) {
  var getButtonLabel = function getButtonLabel() {var
    translate = props.translate,emailIsChecked = props.emailIsChecked,emailIsExist = props.emailIsExist,isForgotPassword = props.isForgotPassword;

    if (!emailIsChecked) {return translate('continue');}
    if (emailIsExist && !isForgotPassword) {return translate('login');}
    if (emailIsExist && isForgotPassword) {return translate('submit');}
    if (!emailIsExist) {return translate('register');}

    return translate('submit');
  };

  var shouldRenderAgentDetails = function shouldRenderAgentDetails() {var
    emailIsChecked = props.emailIsChecked,emailIsExist = props.emailIsExist,shouldChangeUserType = props.shouldChangeUserType,isForgotPassword = props.isForgotPassword;

    return props.isAgent && emailIsChecked && !emailIsExist || shouldChangeUserType && !isForgotPassword;
  };

  var handleSubmit = function handleSubmit(evt) {
    if (props.captcha) {
      props.handleSubmit(evt);
    }
  };

  var fetchReCaptchaToken = function fetchReCaptchaToken(evt) {
    props.fetchReCaptchaToken(evt);
    props.handleSubmit(evt);
  };

  var renderPasswordField = function renderPasswordField() {var
    emailIsChecked = props.emailIsChecked,emailIsExist = props.emailIsExist,translate = props.translate,isForgotPassword = props.isForgotPassword;
    var passwordText = translate(emailIsChecked && !emailIsExist ? 'createPassword' : 'password');

    return emailIsChecked && !isForgotPassword &&
    _react2.default.createElement('div', { className: styles.formGroup },
      _react2.default.createElement('div', { className: styles.label }, passwordText),
      _react2.default.createElement(_reduxForm.Field, {
        name: 'password',
        component: _RealtorField2.default,
        type: 'password',
        validate: [_reduxFormValidators.required],
        placeholder: passwordText.toString(),
        translateForError: props.rootTranslate('errorFieldMessages'),
        isRtl: props.isRtl,
        id: idPrefix + '-password',
        htmlFor: idPrefix + '-password' }));



  };

  var renderNumberCode = function renderNumberCode() {var
    phoneIsChecked = props.phoneIsChecked;

    return phoneIsChecked &&
    _react2.default.createElement('div', { className: styles.formGroup },
      _react2.default.createElement('div', { className: styles.label }, props.translate('code')),
      _react2.default.createElement(_reduxForm.Field, {
        name: 'numberCode',
        component: _RealtorField2.default,
        type: 'text',
        validate: [_reduxFormValidators.required],
        placeholder: props.translate('code'),
        translateForError: props.rootTranslate('errorFieldMessages'),
        isRtl: props.isRtl,
        id: idPrefix + '-numberCode',
        htmlFor: idPrefix + '-numberCode' }));



  };

  var renderForgotPassword = function renderForgotPassword() {var
    emailIsChecked = props.emailIsChecked,emailIsExist = props.emailIsExist,isForgotPassword = props.isForgotPassword,toggleForgotPassword = props.toggleForgotPassword;

    if (emailIsChecked && emailIsExist) {
      return (
        _react2.default.createElement('a', { className: styles.forgotPassword, onClick: toggleForgotPassword }, props.translate(isForgotPassword ? 'backToLogin' : 'forgotPassword')));

    }

    return null;
  };

  var renderTermsAndCondition = function renderTermsAndCondition() {var
    emailIsChecked = props.emailIsChecked,emailIsExist = props.emailIsExist;

    if (!emailIsChecked || emailIsChecked && emailIsExist) {
      return null;
    }var

    translate = props.translate;
    var delimiter = translate('delimiter')() &&
    _react2.default.createElement('span', { className: !translate('delimiter')() ? styles.delimiter : '' },
      translate('delimiter'));



    return (
      _react2.default.createElement('div', { className: styles.termsAndCondition },
        _react2.default.createElement(_reduxForm.Field, {
          name: 'term-of-use',
          id: 'term-of-use',
          type: 'checkbox',
          component: function component(_ref) {var _cx;var id = _ref.id,input = _ref.input,meta = _ref.meta;return (
              _react2.default.createElement(_components.OMCheckbox, {
                id: id,
                field: input,
                className: (0, _classnames2.default)(styles.checkbox, (_cx = {}, _cx[styles.invalid] = meta.error && !meta.active && meta.submitFailed, _cx)) }));},


          validate: [_reduxFormValidators.required] }),


        _react2.default.createElement('p', { className: styles.checkboxLabel },

          _react2.default.createElement('span', null, translate('confirm')), ' ', _react2.default.createElement('a', { href: (0, _appendLocale2.default)(props.locale, '/terms'), target: '_blank', rel: 'noopener noreferrer' },
            translate('termsOfUse')), ' ',
          delimiter, ' ', _react2.default.createElement('a', { href: (0, _appendLocale2.default)(props.locale, '/privacy'), target: '_blank', rel: 'noopener noreferrer' },
            translate('privacy')))));




  };

  var renderLicenseNumber = function renderLicenseNumber() {return shouldRenderAgentDetails() &&
    _react2.default.createElement('div', { className: styles.formGroup },
      _react2.default.createElement('div', { className: styles.label }, props.translate('licenseNumber')),
      _react2.default.createElement(_reduxForm.Field, {
        name: 'license_number',
        type: 'text',
        component: _RealtorField2.default,
        placeholder: props.translate('licenseNumber')(),
        validate: [_reduxFormValidators.licenseNumber],
        translate: props.translate,
        translateForError: props.rootTranslate('errorFieldMessages'),
        isRtl: props.isRtl,
        isMobile: props.isMobile,
        id: idPrefix + '-license_number',
        htmlFor: idPrefix + '-license_number' }));};




  var renderCompanyName = function renderCompanyName() {return shouldRenderAgentDetails() &&
    _react2.default.createElement('div', { className: styles.formGroup },
      _react2.default.createElement('div', { className: styles.label }, props.translate('companyName')),
      _react2.default.createElement(_reduxForm.Field, {
        name: 'company_name',
        type: 'text',
        component: _RealtorField2.default,
        placeholder: props.translate('companyName')(),
        validate: [_reduxFormValidators.required],
        translate: props.translate,
        translateForError: props.rootTranslate('errorFieldMessages'),
        isRtl: props.isRtl,
        isMobile: props.isMobile,
        id: idPrefix + '-company_name',
        htmlFor: idPrefix + '-company_name' }));};




  var renderErrorMessage = function renderErrorMessage() {return !!props.error && !props.phoneNumberNotVerified &&
    _react2.default.createElement('div', { className: styles.errorMessage }, props.error);};


  var renderPhoneErrorMessage = function renderPhoneErrorMessage() {return !!props.phoneNumberNotVerified &&
    _react2.default.createElement('div', { className: styles.errorMessage }, props.phoneNumberNotVerified);};


  return (
    _react2.default.createElement('form', { className: styles.formWrapper },
      props.emailIsChecked &&
      _react2.default.createElement('h4', null, props.translate(props.emailIsExist ? 'loginMessage' : 'registerMessage')),

      _react2.default.createElement('div', { className: styles.formGroup },
        _react2.default.createElement('div', { className: styles.label }, props.isForgotPassword ?
          props.rootTranslate('userAuthentication', 'forgotPassword', 'title') :
          props.translate('email')),

        _react2.default.createElement(_reduxForm.Field, {
          name: 'email',
          component: _RealtorField2.default,
          onChange: props.handleEmailChange,
          type: 'text',
          validate: [props.emailValidate],
          placeholder: '' + props.translate('email').toString(),
          translateForError: props.rootTranslate('errorFieldMessages'),
          isRtl: props.isRtl,
          id: idPrefix + '-email',
          htmlFor: idPrefix + '-email' })),



      renderPasswordField(),

      renderNumberCode(),

      renderForgotPassword(),

      renderLicenseNumber(),

      renderCompanyName(),

      renderTermsAndCondition(),

      renderErrorMessage(),

      renderPhoneErrorMessage(),

      props.isForgotPassword && _react2.default.createElement('div', { className: styles.forgotPasswordDescription }, props.rootTranslate('userAuthentication', 'forgotPassword', 'description')),

      props.emailIsValid ? _react2.default.createElement('button', {
          disabled: props.sending || !props.emailIsValid,
          className: (0, _classnames2.default)('btn', 'btn-primary', styles.actionButton),
          onClick: props.emailIsValid && props.handleSubmit },


        props.sending ?
        _react2.default.createElement('i', { className: 'icon icon-om-spinner om-pulse' }) :
        getButtonLabel()) :

      _react2.default.createElement(_components.GoogleReCaptcha, {
          locale: props.locale,
          fetchToken: fetchReCaptchaToken,
          doReset: props.sending,
          userAuthentication: true },

        _react2.default.createElement('button', {
            disabled: props.sending || !props.phoneIsValid,
            className: (0, _classnames2.default)('btn', 'btn-primary', styles.actionButton),
            onClick: props.phoneIsValid && handleSubmit },


          props.sending ?
          _react2.default.createElement('i', { className: 'icon icon-om-spinner om-pulse' }) :
          getButtonLabel()))));












};

PublishAuthentication.propTypes = {
  isAgent: _propTypes2.default.bool,
  isMobile: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  locale: _propTypes2.default.string,
  emailIsChecked: _propTypes2.default.bool,
  emailIsExist: _propTypes2.default.bool,
  phoneIsChecked: _propTypes2.default.bool,
  phoneIsValid: _propTypes2.default.bool,
  sending: _propTypes2.default.bool,
  isForgotPassword: _propTypes2.default.bool,
  translate: _propTypes2.default.func,
  rootTranslate: _propTypes2.default.func,
  toggleForgotPassword: _propTypes2.default.func,
  handleEmailChange: _propTypes2.default.func,
  handleSubmit: _propTypes2.default.func,
  error: _propTypes2.default.string,
  phoneNumberNotVerified: _propTypes2.default.string,
  shouldChangeUserType: _propTypes2.default.bool,
  socialNetworkAuthentication: _propTypes2.default.func,
  emailValidate: _propTypes2.default.func,
  emailIsValid: _propTypes2.default.bool,
  fetchReCaptchaToken: _propTypes2.default.func,
  captcha: _propTypes2.default.string };exports.default =


PublishAuthentication;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PublishAuthentication/PublishAuthentication.js
// module id = 2813
// module chunks = 0